import type { Price } from '@shared/dream-components';

import { defaultCurrency } from '~/constants/localizationDefaults';

import { PriceInterval } from '~/interfaces/subscriptions';

export const generateInitialPaymentRequest = (selectedPrice: Price, donationAmountCents: number) => {
  if (selectedPrice?.interval === PriceInterval.DONATION) {
    return {
      currency: selectedPrice?.currency || defaultCurrency,
      label: selectedPrice?.cta || 'Pay now',
      amount: donationAmountCents,
    };
  }

  return {
    currency: selectedPrice?.currency || defaultCurrency,
    label: selectedPrice?.cta || 'Pay now',
    amount: selectedPrice?.amount_cents || 0,
  };
};
